import {PlayerColor} from '@colonist/game-states'
import {type ImageURL} from '@colonist/types'
import KnightLevel1InactiveRed from '@static/images/knight_level1_inactive_red.svg'
import KnightLevel1InactiveBlue from '@static/images/knight_level1_inactive_blue.svg'
import KnightLevel1InactiveOrange from '@static/images/knight_level1_inactive_orange.svg'
import KnightLevel1InactiveGreen from '@static/images/knight_level1_inactive_green.svg'
import KnightLevel1InactiveBlack from '@static/images/knight_level1_inactive_black.svg'
import KnightLevel1InactiveBronze from '@static/images/knight_level1_inactive_bronze.svg'
import KnightLevel1InactiveSilver from '@static/images/knight_level1_inactive_silver.svg'
import KnightLevel1InactiveGold from '@static/images/knight_level1_inactive_gold.svg'
import KnightLevel1InactiveWhite from '@static/images/knight_level1_inactive_white.svg'
import KnightLevel1InactivePurple from '@static/images/knight_level1_inactive_purple.svg'
import KnightLevel1InactiveMysticBlue from '@static/images/knight_level1_inactive_mysticblue.svg'
import KnightLevel1InactivePink from '@static/images/knight_level1_inactive_pink.svg'

export const KNIGHT_LEVEL1_INACTIVE_IMAGE_PATH: Record<PlayerColor, ImageURL> = {
    [PlayerColor.None]: '' as ImageURL,
    [PlayerColor.Red]: KnightLevel1InactiveRed,
    [PlayerColor.Blue]: KnightLevel1InactiveBlue,
    [PlayerColor.Orange]: KnightLevel1InactiveOrange,
    [PlayerColor.Green]: KnightLevel1InactiveGreen,
    [PlayerColor.Black]: KnightLevel1InactiveBlack,
    [PlayerColor.Bronze]: KnightLevel1InactiveBronze,
    [PlayerColor.Silver]: KnightLevel1InactiveSilver,
    [PlayerColor.Gold]: KnightLevel1InactiveGold,
    [PlayerColor.White]: KnightLevel1InactiveWhite,
    [PlayerColor.Purple]: KnightLevel1InactivePurple,
    [PlayerColor.MysticBlue]: KnightLevel1InactiveMysticBlue,
    [PlayerColor.Pink]: KnightLevel1InactivePink,
}
